import axios from 'axios';
import Sortable from 'sortablejs';

export default class psProfileTools {
    constructor() {
        const container = document.getElementById('profile-tools');
        if (!container) {
            return;
        }

        this.container = container;

        this._initSortable();
        this._initEdit();
    }

    _initSortable() {
        const editList = this.container.querySelector('.profile-tools__edit-items');
        if (!editList) {
            return;
        }

        const loader = document.querySelector('.ajax-loading-edit-tools');
        const options = {
            handle: '.profile-tools__item-drag-wrapper',
            onUpdate: event => {
                loader.toggleAttribute('hidden', false);

                const items = event.from.querySelectorAll('.profile-tools__item-container');
                const tools = [];

                for (let i = 0; i < items.length; i++) {
                    const item = items[i];
                    item.setAttribute('data-index', i);
                    const cb = item.querySelector('.profil-unit-item');
                    if (cb && cb.checked) {
                        tools.push(item.getAttribute('data-id'));
                    }
                }

                axios.post('/api/ps/profile/tools/sort', tools)
                    .then(response => {
                        const list = document.getElementById('updatedtoolspartial');
                        list.innerHTML = response.data;

                        const items = list.querySelector('.profile-tools__items');
                        items && items.toggleAttribute('hidden', true);
                    })
                    .catch(error => {
                        this._error(error);
                    })
                    .finally(() => {
                        loader.toggleAttribute('hidden', true);
                    });
            }
        };

        Sortable.create(editList, options);
    }

    _initEdit() {
        const editButton = this.container.querySelector('.profile-tools__profile-tools-edit');
        editButton && editButton.addEventListener('click', () => {
            const editList = document.getElementById(editButton.getAttribute('aria-controls'));
            if (!editList) {
                return;
            }

            const expanded = editButton.classList.toggle('profile-tools__edit-check-icon');
            const list = this.container.querySelector('#updatedtoolspartial .profile-tools__items');
            list.toggleAttribute('hidden', !editList.toggleAttribute('hidden', !expanded));
            editButton.setAttribute('aria-expanded', expanded);
        });

        const editContainer = this.container.querySelector('.profile-tools__edit-items');
        editContainer && editContainer.addEventListener('change', event => {
            if (!event.target.classList.contains('profil-unit-item')) {
                return;
            }

            event.preventDefault();

            const loader = this.container.querySelector('.ajax-loading-edit-tools');
            loader.toggleAttribute('hidden', false);

            const cb = event.target;
            const url = '/api/ps/profile/tools/' + (cb.checked ? 'add' : 'remove');

            axios.post(url, { id: cb.id })
                .then(response => {
                    const div = document.createElement('div');
                    div.innerHTML = response.data;
                    div.firstElementChild.toggleAttribute('hidden', true);

                    const wrapper = document.getElementById('updatedtoolspartial');
                    wrapper.firstElementChild.replaceWith(div.firstElementChild);

                    if (!editContainer.querySelector('.profil-unit-item:checked')) {
                        for (const cb of editContainer.querySelectorAll('.profile-unit-item')) {
                            cb.checked = cb.dataset.default === 'true';
                        }
                    }
                })
                .catch(error => {
                    this._error(error);
                })
                .finally(() => {
                    loader.toggleAttribute('hidden', true);
                });
        });
    }

    _error(error) {
        const id = error && error.response && error.response.status === 401 ? 'ps-profile-logged-out' : 'ps-profile-generic-error';
        const node = document.getElementById(id);
        node && alert(node.value);
    }
}
